var userAgent = navigator.userAgent;

var isSafari = userAgent.includes('Safari') && !userAgent.includes('Chrome');
var isiPhone = userAgent.includes('iPhone');

export const isIphone = isSafari && isiPhone;
